import { ConnectionStatus } from './connection.model';

/*
 * TT-192. ACCEPTED means the installer said yes and the COMPANY still has to
 * approve. It used to read "Ready" here and "Accepted" to a company, both in
 * the same green as APPROVED, so a connection waiting on the company looked
 * finished. 14 sat like that across 8 companies, the oldest for 1,151 days.
 * Nobody was ignoring them; the screen said there was nothing to do.
 */
export const CONNECTION_STATUS_LABEL = {
  [ConnectionStatus.Pending]: 'Invited',
  [ConnectionStatus.Accepted]: 'Needs approval',
  [ConnectionStatus.Approved]: 'Approved',
  [ConnectionStatus.Declined]: 'Declined',
  [ConnectionStatus.Disconnected]: 'Disconnected',
  [ConnectionStatus.NoSubscription]: 'No Subscription',
};

export const COMPANY_CONNECTION_STATUS_LABEL = {
  [ConnectionStatus.Pending]: 'Invited',
  [ConnectionStatus.Accepted]: 'Needs your approval',
  [ConnectionStatus.Approved]: 'Approved',
  [ConnectionStatus.Declined]: 'Declined',
  [ConnectionStatus.Disconnected]: 'Disconnected',
  [ConnectionStatus.NoSubscription]: 'No Subscription',
};

export const INSTALLER_CONNECTION_STATUS_LABEL = {
  [ConnectionStatus.Pending]: 'Pending Response',
  [ConnectionStatus.Accepted]: 'Awaiting Approval',
  [ConnectionStatus.Approved]: 'Approved',
  [ConnectionStatus.Declined]: 'Declined',
  [ConnectionStatus.Disconnected]: 'Disconnected',
  [ConnectionStatus.NoSubscription]: 'No Subscription',
};

export const CONNECTION_STATUS_COLOR = {
  [ConnectionStatus.Pending]: 'gc-light-yellow',
  // Waiting on somebody, so it gets the waiting colour rather than the same
  // green as APPROVED. This reads correctly from both sides: the company sees
  // "Needs your approval", the installer sees "Awaiting Approval".
  [ConnectionStatus.Accepted]: 'gc-light-yellow',
  [ConnectionStatus.Approved]: 'gc-green',
  [ConnectionStatus.Declined]: 'danger',
  [ConnectionStatus.Disconnected]: 'light',
  [ConnectionStatus.NoSubscription]: 'medium',
};
